const ValuationOriginEnum = Object.freeze({
    COMPANIES_HOUSE: 'COMPANIES_HOUSE',
    FUND_MANAGER: 'FUND_MANAGER',
    GAZETTE: 'GAZETTE',
    GROWTHINVEST: 'GROWTHINVEST',
    MORNINGSTAR: 'MORNINGSTAR'
});

export default ValuationOriginEnum;
